import { ReusableButton } from "../../voyage-pnl/components/ReusableTableButton";
import { FormStatus } from "../models/voyage-assesment.models";
import FeedbackIcon from "./FeedbackIcon";
import { useNavigate } from "react-router";

type Props = {
  tcCode: string | undefined;
  voyageNo: string | undefined;
  status: FormStatus;
};

const AssesmentCompleted = ({ tcCode, voyageNo, status }: Props) => {
  const navigate = useNavigate();
  const canShowFeedback = status === "done" || status === "sent";

  const goToVoyagePage = () => {
    navigate(`/voyage/details/${tcCode}/${voyageNo}`);
  };

  const renderText = (status: FormStatus) => {
    switch (status) {
      case "sent":
        return "Thank your for the feedback";
      case "done":
        return "You already completed this assessment";
      default:
        return null;
    }
  };

  return canShowFeedback ? (
    <>
      <div className="flex h-[266px] flex-col items-center justify-center">
        <FeedbackIcon />
        <p className="mt-8 text-lg font-bold">{renderText(status)}</p>

        <ReusableButton onClickHandler={goToVoyagePage} buttonText="Close" width={80} className="mt-8" />
      </div>
    </>
  ) : null;
};

export default AssesmentCompleted;
